/**
 * Unauthenticated client for the public read-only invoice view
 * (`/api/v1/public/invoices/:token`). No bearer — anonymous customers opening a
 * shared "view your invoice" link.
 */
import axios from 'axios';

import { assetUrl } from './publicApi.js';

export interface PublicInvoice {
  number: string;
  date: string;
  dueDate: string | null;
  status: string;
  currencyCode: string;
  seller: { name: string; logoUrl: string | null; tagline: string | null; email: string | null; phone: string | null; addressLines: string[] };
  billTo: { name: string; addressLines: string[] };
  lines: Array<{ description: string; quantity: string; unitPrice: string; taxAmount: string; lineTotal: string }>;
  subtotal: string;
  taxTotal: string;
  discountTotal: string;
  total: string;
  amountPaid: string;
  amountDue: string;
  notes: string | null;
  /** Backend per-currency decimals (code → exponent) so IQD renders as whole dinars. */
  currencyDecimals: Record<string, number>;
}

const rawBase = import.meta.env.VITE_API_BASE_URL || '/api/v1';
const client = axios.create({ baseURL: rawBase, headers: { 'Content-Type': 'application/json' } });

export async function getPublicInvoice(token: string): Promise<PublicInvoice> {
  return (await client.get<PublicInvoice>(`/public/invoices/${encodeURIComponent(token)}`)).data;
}

export { assetUrl };
